enum SHARED_COOKIE {
  CountCityCV = "donut-count-city-cv",
  RecordOnlineHubAddressCV = "donut-record-online-hub-address-cv",
  RecordOnlineHubDateCV = "donut-record-online-hub-date-cv",
  RecordOnlineHubEmployeeCV = "donut-record-online-hub-employee-cv",
  RecordOnlineHubServicesCV = "donut-record-online-hub-services-cv",
  RecordOnlineHubTimeCV = "donut-record-online-hub-time-cv",
  RefreshTokenCRM = "donut-refresh-token-crm",
  RefreshTokenCV = "donut-refresh-token-cv",
  RefreshTokenExpiresCRM = "donut-refresh-token-expires-crm",
  RefreshTokenExpiresCV = "donut-refresh-token-expires-cv",
  UserCityCV = "donut-user-city-cv",
}

export { SHARED_COOKIE };
